import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_BREAKPOINTS } from '@/constants/breakpoints';
import { Z_INDEX } from '@/constants/z-index';
import { flexCenterAligned, flexColumn, openingEffect } from '@/styles/common';

export const ToggleButton = styled.button`
  ${flexCenterAligned};
  position: absolute;
  top: 43px;
  right: 16px;
  width: 34px;
  height: 34px;
  background-color: transparent;
  border: 1px solid var(--border-main);
  border-radius: 28px;
  cursor: pointer;
  color: var(--textAndLabels-main);
  transition: all 0.3s ease;
  z-index: ${Z_INDEX.NAVIGATION};

  &:hover {
    background: var(--bg-secondary);
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const Popup = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  ${flexColumn};
  gap: 4px;
  background: var(--bg-main);
  border-radius: 16px 16px 0 0;
  padding: 25px 16px 20px;
  z-index: ${Z_INDEX.BOTTOM_SHEET};
  ${openingEffect(80)};

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const PopupTitle = styled(Typography)`
  padding-bottom: 12px;
`;

export const PopupItem = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: start;
  padding: 13px 0;
  color: var(--textAndLabels-main);
`;

export const PopupItemLogout = styled(PopupItem)`
  color: var(--system-red);
`;
